(function () {
  var section = document.querySelector('.oddit-section-main-collection');
  if (!section) return;

  // Filter panel: mobile slide-in drawer (static sidebar on desktop).
  // Accordions + see-more are handled globally in oddit-interactions.js.
  var filterOpenBtn = section.querySelector('[data-mobile-filter-toggle]');
  var filterCloseBtn = section.querySelector('[data-filters-close]');
  var filterOverlay = section.querySelector('[data-filters-overlay]');
  var filterForm = section.querySelector('.oddit-section-main-collection__filters-form');

  function openFilters() {
    section.classList.add('is-filters-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    section.classList.remove('is-filters-open');
    document.body.style.overflow = '';
  }

  if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilters);
  if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilters);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && section.classList.contains('is-filters-open')) closeFilters();
  });

  // Crossing to desktop turns the panel into a static sidebar — drop any leftover
  // open state / scroll lock from the mobile overlay.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) closeFilters();
  });

  // --- Async filtering via the Shopify Section Rendering API (no full reload) ---
  var abortCtl;

  function renderUrl(url, opts) {
    opts = opts || {};
    if (abortCtl) abortCtl.abort();
    abortCtl = new AbortController();
    section.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + section.id;
    fetch(fetchUrl, { signal: abortCtl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Products grid always swaps. The filter body (per-tag counts/checked state)
        // swaps too, except while the mobile drawer is open (keepDrawer) so the user's
        // in-progress selection and scroll position stay put.
        var selectors = ['.oddit-section-main-collection__products'];
        if (!opts.keepDrawer) selectors.push('.oddit-section-main-collection__filters-body');
        selectors.forEach(function (sel) {
          var next = doc.querySelector(sel);
          var cur = section.querySelector(sel);
          if (next && cur) cur.replaceWith(next);
        });

        // Pagination appears/disappears as the result count changes.
        var nextPag = doc.querySelector('.oddit-section-main-collection__pagination');
        var curPag = section.querySelector('.oddit-section-main-collection__pagination');
        if (nextPag && curPag) curPag.replaceWith(nextPag);
        else if (nextPag && !curPag) {
          var grid = section.querySelector('.oddit-section-main-collection__products');
          if (grid) grid.after(nextPag);
        } else if (!nextPag && curPag) curPag.remove();

        // The swap replaced the marquee's DOM (it renders inside the grid) —
        // re-measure and restart it on the fresh nodes. Hoisted from below.
        initMarquee();

        syncHeaderCount();

        section.classList.remove('is-loading');
        if (opts.history !== false) {
          if (opts.history === 'replace') history.replaceState({ odditFilters: true }, '', url);
          else history.pushState({ odditFilters: true }, '', url);
        }
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        window.location.href = url; // graceful fallback to a normal reload
      });
  }

  // The header count is the whole collection. The grid's data-product-count is
  // the filtered total, so keep the header in step after each filter render.
  function syncHeaderCount() {
    var grid = section.querySelector('.oddit-section-main-collection__products');
    var countEl = document.querySelector('[data-collection-product-count]');
    if (!grid || !countEl) return;
    var count = grid.getAttribute('data-product-count');
    if (count != null && count !== '') countEl.textContent = count;
  }

  syncHeaderCount();

  function filtersUrl() {
    var params = new URLSearchParams(new FormData(filterForm));
    var qs = params.toString();
    return filterForm.action + (qs ? '?' + qs : '');
  }

  if (filterForm) {
    // Async filtering is desktop-only. On mobile the drawer's View Products button submits
    // the form normally (full reload), so ticking filters does nothing until it's tapped.
    filterForm.addEventListener('change', function (e) {
      if (window.innerWidth < 990) return;
      if (!e.target.matches('input, select')) return;
      renderUrl(filtersUrl());
    });
  }

  // Pagination + sort: async on desktop only. Delegated so the handlers survive the
  // grid/pagination being swapped out. On mobile these are plain links that reload.
  section.addEventListener('click', function (e) {
    if (window.innerWidth < 990) return;

    var page = e.target.closest('a.oddit-section-main-collection__page');
    if (page) {
      e.preventDefault();
      renderUrl(page.getAttribute('href'));
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Sort: async too, and merge with the current filters so sorting never drops them.
    var sortOpt = e.target.closest('a.oddit-section-main-collection__sort-option');
    if (sortOpt) {
      e.preventDefault();
      var chosen = new URL(sortOpt.href, location.origin).searchParams.get('sort_by');
      var url;
      if (filterForm) {
        // Keep the form's hidden sort_by in sync so a later filter change preserves this sort.
        var hidden = filterForm.querySelector('input[name="sort_by"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'sort_by';
          filterForm.appendChild(hidden);
        }
        hidden.value = chosen;
        var params = new URLSearchParams(new FormData(filterForm));
        url = filterForm.action + '?' + params.toString();
      } else {
        url = sortOpt.getAttribute('href');
      }
      renderUrl(url);

      // Update this dropdown's active state, button label, and close it.
      var menu = sortOpt.closest('.oddit-section-main-collection__sort-menu');
      if (menu) {
        menu.querySelectorAll('.oddit-section-main-collection__sort-option').forEach(function (o) {
          o.classList.remove('oddit-section-main-collection__sort-option--active');
          o.setAttribute('aria-selected', 'false');
        });
        sortOpt.classList.add('oddit-section-main-collection__sort-option--active');
        sortOpt.setAttribute('aria-selected', 'true');
        menu.hidden = true;
        var wrap = menu.closest('[data-sort]');
        var toggle = wrap && wrap.querySelector('[data-sort-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          var label = toggle.querySelector('span');
          if (label) label.textContent = 'SORT: ' + sortOpt.textContent.trim().toUpperCase();
        }
      }
    }
  });

  window.addEventListener('popstate', function () {
    renderUrl(location.href, { history: false });
  });

  // Filter group accordions
  var filterGroups = section.querySelectorAll('.oddit-section-main-collection__filter-group');
  filterGroups.forEach(function (group) {
    var header = group.querySelector('.oddit-section-main-collection__filter-group-header');
    var list = group.querySelector('.oddit-section-main-collection__filter-list');
    if (!header || !list) return;

    header.addEventListener('click', function () {
      var isOpen = group.getAttribute('data-open') === 'true';
      var next = !isOpen;
      group.setAttribute('data-open', String(next));
      header.setAttribute('aria-expanded', String(next));
      list.hidden = !next;
    });
  });

  // Quick filter tabs are collection links — active state is server-rendered from
  // the viewed collection, so no client-side toggle is needed.

  // Sort dropdowns — options are links that set ?sort_by=; Shopify sorts natively on reload.
  var sortWraps = section.querySelectorAll('[data-sort]');
  sortWraps.forEach(function (wrap) {
    var btn = wrap.querySelector('[data-sort-toggle]');
    var menu = wrap.querySelector('.oddit-section-main-collection__sort-menu');
    if (!btn || !menu) return;

    function close() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  // Pagination click (visual only)
  var pages = section.querySelectorAll('.oddit-section-main-collection__page');
  pages.forEach(function (page) {
    page.addEventListener('click', function () {
      if (page.classList.contains('oddit-section-main-collection__page--next')) return;
      pages.forEach(function (p) {
        p.classList.remove('oddit-section-main-collection__page--active');
        p.removeAttribute('aria-current');
      });
      page.classList.add('oddit-section-main-collection__page--active');
      page.setAttribute('aria-current', 'page');
    });
  });

  // Featured ingredients marquee — seamless infinite loop. The marquee lives
  // inside the products grid, which async pagination/filtering swaps out, so
  // everything is re-bound through initMarquee() after every render.
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var marqueeTrack = null;
  var marqueeRo = null;

  function setMarqueePlay(running) {
    if (marqueeTrack) {
      marqueeTrack.style.animationPlayState = running ? 'running' : 'paused';
    }
  }

  function initMarquee() {
    if (marqueeRo) {
      marqueeRo.disconnect();
      marqueeRo = null;
    }
    marqueeTrack = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!marqueeTrack || !firstSet) return;
    var track = marqueeTrack;

    function measure() {
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = firstSet.scrollWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    measure();
    setMarqueePlay(!reducedMotion.matches && !document.hidden);

    // Observe the set, not the section: the section's width never changes, so a
    // section-only observer misses the re-measure when webfonts land and the set grows.
    marqueeRo = new ResizeObserver(function () {
      measure();
    });
    marqueeRo.observe(firstSet);
    marqueeRo.observe(section);
  }

  initMarquee();

  reducedMotion.addEventListener('change', function (e) {
    setMarqueePlay(!e.matches);
  });

  document.addEventListener('visibilitychange', function () {
    if (reducedMotion.matches) return;
    setMarqueePlay(!document.hidden);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.contains(section) && marqueeRo) marqueeRo.disconnect();
  });
})();